import { render, staticRenderFns } from "./BaColumnOptions.vue?vue&type=template&id=696de7e1&scoped=true&"
import script from "./BaColumnOptions.vue?vue&type=script&lang=js&"
export * from "./BaColumnOptions.vue?vue&type=script&lang=js&"
import style0 from "./BaColumnOptions.vue?vue&type=style&index=0&id=696de7e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696de7e1",
  null
  
)

export default component.exports